import { render, staticRenderFns } from "./ScheduleServicePackageWeek.vue?vue&type=template&id=0b822223&scoped=true"
import script from "./ScheduleServicePackageWeek.vue?vue&type=script&lang=js"
export * from "./ScheduleServicePackageWeek.vue?vue&type=script&lang=js"
import style0 from "./ScheduleServicePackageWeek.vue?vue&type=style&index=0&id=0b822223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b822223",
  null
  
)

export default component.exports